document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCifras();
  initGaleriaProducto();
  initCantidad();
  initVariantes();
  initFaq();
  initAyudaBuscador();
});

/* Revelado al hacer scroll (compartido por todas las secciones) */
function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.18 }
  );
  els.forEach(function (el) { obs.observe(el); });
}

/* Cifras animadas (count-up) */
function initCifras() {
  var items = document.querySelectorAll('[data-mt-cifra]');
  if (!items.length || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-mt-cifra'));
        var suffix = el.getAttribute('data-mt-sufijo') || '';
        var duration = 1400;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = Math.round(target * eased);
          el.textContent = value + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );
  items.forEach(function (el) { obs.observe(el); });
}

/* Galería de producto: cambia la imagen principal al clicar una miniatura */
function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-mt-imagen-principal]');
  var minis = galeria.querySelectorAll('[data-mt-miniatura]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      if (!full) return;
      principal.src = full;
      principal.alt = alt;
      minis.forEach(function (m) { m.classList.remove('is-activa'); });
      mini.classList.add('is-activa');
    });
  });
}

/* Selector de cantidad */
function initCantidad() {
  document.querySelectorAll('[data-mt-cantidad]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var menos = wrap.querySelector('[data-mt-menos]');
    var mas = wrap.querySelector('[data-mt-mas]');
    if (!input || !menos || !mas) return;
    menos.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
    mas.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
  });
}

/* Selector de variantes: localiza la variante exacta según las opciones elegidas */
function initVariantes() {
  var form = document.querySelector('[data-mt-form-producto]');
  if (!form) return;
  var dataEl = form.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var botones = form.querySelectorAll('[data-mt-valor-opcion]');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = form.querySelector('[data-mt-precio-actual]');
  var precioAntesEl = form.querySelector('[data-mt-precio-antes]');
  var btnComprar = form.querySelector('[data-mt-btn-comprar]');

  function estadoActual() {
    var estado = {};
    form.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
      var activo = grupo.querySelector('.is-activo');
      if (activo) estado[grupo.getAttribute('data-mt-opcion')] = activo.getAttribute('data-mt-valor-opcion');
    });
    return estado;
  }

  function encontrarVariante(estado) {
    return variantes.find(function (v) {
      return v.options.every(function (opt, i) {
        return estado[String(i)] === opt || Object.values(estado).indexOf(opt) > -1;
      });
    });
  }

  function actualizar() {
    var estado = estadoActual();
    var valores = Object.keys(estado).map(function (k) { return estado[k]; });
    var variante = variantes.find(function (v) {
      return v.options.length === valores.length && v.options.every(function (o, i) { return o === valores[i]; });
    });
    if (!variante) return;
    idInput.value = variante.id;
    if (precioEl) precioEl.textContent = formatearDinero(variante.price);
    if (precioAntesEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioAntesEl.textContent = formatearDinero(variante.compare_at_price);
        precioAntesEl.style.display = '';
      } else {
        precioAntesEl.style.display = 'none';
      }
    }
    if (btnComprar) {
      if (variante.available) {
        btnComprar.disabled = false;
        btnComprar.textContent = btnComprar.getAttribute('data-texto-disponible') || btnComprar.textContent;
      } else {
        btnComprar.disabled = true;
        btnComprar.textContent = btnComprar.getAttribute('data-texto-agotado') || 'Agotado';
      }
    }
  }

  function formatearDinero(centavos) {
    return (centavos / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
  }

  botones.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var grupo = btn.closest('[data-mt-opcion]');
      grupo.querySelectorAll('[data-mt-valor-opcion]').forEach(function (b) { b.classList.remove('is-activo'); });
      btn.classList.add('is-activo');
      actualizar();
    });
  });
}

/* Buscador de la página de Ayuda: coincidencia simple por palabras clave */
function initAyudaBuscador() {
  var wrap = document.querySelector('[data-mt-ayuda]');
  if (!wrap) return;
  var dataEl = wrap.querySelector('[data-mt-ayuda-json]');
  var input = wrap.querySelector('[data-mt-ayuda-input]');
  var boton = wrap.querySelector('[data-mt-ayuda-boton]');
  var resultado = wrap.querySelector('[data-mt-ayuda-resultado]');
  var resPregunta = wrap.querySelector('[data-mt-ayuda-resultado-pregunta]');
  var resRespuesta = wrap.querySelector('[data-mt-ayuda-resultado-respuesta]');
  if (!dataEl || !input || !boton || !resultado) return;

  var preguntas;
  try {
    preguntas = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  function normalizar(txt) {
    return (txt || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '');
  }

  function buscar(consulta) {
    var terminos = normalizar(consulta).split(/\s+/).filter(Boolean);
    if (!terminos.length) return null;
    var mejor = null;
    var mejorPuntos = 0;
    preguntas.forEach(function (p) {
      var textoIndexado = normalizar(p.pregunta + ' ' + p.palabras + ' ' + p.respuesta);
      var puntos = 0;
      terminos.forEach(function (t) {
        if (textoIndexado.indexOf(t) > -1) puntos += 1;
      });
      if (puntos > mejorPuntos) {
        mejorPuntos = puntos;
        mejor = p;
      }
    });
    return mejor;
  }

  function mostrarResultado(p) {
    if (!p) {
      resPregunta.textContent = 'No he encontrado una respuesta exacta';
      resRespuesta.textContent = 'Prueba con otras palabras, o consulta el listado completo aquí abajo.';
    } else {
      resPregunta.textContent = p.pregunta;
      resRespuesta.textContent = p.respuesta;
    }
    resultado.hidden = false;
  }

  function ejecutarBusqueda() {
    var valor = input.value.trim();
    if (!valor) return;
    mostrarResultado(buscar(valor));
  }

  boton.addEventListener('click', ejecutarBusqueda);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      ejecutarBusqueda();
    }
  });
  wrap.querySelectorAll('[data-mt-ayuda-chip]').forEach(function (chip) {
    chip.addEventListener('click', function () {
      input.value = chip.textContent;
      ejecutarBusqueda();
      resultado.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
}

/* FAQ acordeón */
function initFaq() {
  document.querySelectorAll('.mt-faq-item').forEach(function (item) {
    var btn = item.querySelector('.mt-faq-pregunta');
    var respuesta = item.querySelector('.mt-faq-respuesta');
    if (!btn || !respuesta) return;
    btn.addEventListener('click', function () {
      var abierto = item.classList.contains('is-abierto');
      item.closest('.mt-faq-lista').querySelectorAll('.mt-faq-item').forEach(function (i) {
        i.classList.remove('is-abierto');
        i.querySelector('.mt-faq-respuesta').style.maxHeight = null;
      });
      if (!abierto) {
        item.classList.add('is-abierto');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}
